import api from "./api";
import axios from "./axios";

import { SCREEN_CAPTURE_SESSIONS_END_POINT } from "constants/tradeCapture";

const SESSIONS_END_POINT = SCREEN_CAPTURE_SESSIONS_END_POINT;

// Ladder OCR can take 30–60s. Leave headroom so a slow read fails as a
// response the popup can retry, instead of aborting mid-wait.
const multipartConfig = {
  timeout: 180000,
  transformRequest: [
    (data, headers) => {
      if (data instanceof FormData) {
        delete headers["Content-Type"];
      }
      return data;
    },
  ],
};

export const createSession = async (formData) => {
  return await axios.post(SESSIONS_END_POINT, formData, multipartConfig);
};

export const addSessionScreenshot = async (id, formData) => {
  return await axios.post(
    `${SESSIONS_END_POINT}/${id}/screenshots`,
    formData,
    multipartConfig
  );
};

export const validateSession = (id, tableData) =>
  api.post(`${SESSIONS_END_POINT}/${id}/validate`, {}, { table_data: tableData });

export const importSession = (id, payload) =>
  api.post(`${SESSIONS_END_POINT}/${id}/import`, {}, payload);

export const cancelSession = (id) =>
  api.post(`${SESSIONS_END_POINT}/${id}/cancel`);

/** Current vs new for the tenor an Other surface fill replaces. Writes nothing. */
export const previewOtherSurface = (id, payload) =>
  api.post(`${SESSIONS_END_POINT}/${id}/preview-other-surface`, {}, payload);

/** Writes the previewed ladder to the Other surface (needs the preview's surface_version). */
export const fillOtherSurface = (id, payload) =>
  api.post(`${SESSIONS_END_POINT}/${id}/fill-other-surface`, {}, payload);
